import { useState, useEffect } from 'react';
import '../styles/MapComponent.css';
import mainmap from '../assets/Maps/MainMap.jpg';
import minimap1 from '../assets/Maps/1.jpg';
import minimap2 from '../assets/Maps/2.jpg';
import minimap3 from '../assets/Maps/3.jpg';
import minimap4 from '../assets/Maps/4.jpg';
import minimap6 from '../assets/Maps/6.jpg';
import Zicatela from './mapcomponents/Zicatela';
import Punta from './mapcomponents/Punta';
import Colorada from './mapcomponents/Colorada';
import Puertecito from './mapcomponents/Puertecito';
import Palmarito from './mapcomponents/Palmarito';

const translations = {
  en: {
    hotspots: {
      hotspot1: 'Zicatela and Surroundings',
      hotspot2: 'Punta Zicatela',
      hotspot3: 'Punta Colorada',
      hotspot4: 'Puertecito',
      hotspot5: 'Palmarito'
    },
    clickPrompt: 'Click any red dot to lock its description'
  },
  es: {
    hotspots: {
      hotspot1: 'Zicatela y Alrededores',
      hotspot2: 'Punta Zicatela',
      hotspot3: 'Punta Colorada',
      hotspot4: 'Puertecito',
      hotspot5: 'Palmarito'
    },
    clickPrompt: 'Haz clic en cualquier punto rojo para bloquear su descripción'
  }
};


const MapComponent2 = ({ language }) => {

  const [activeHotspotId, setActiveHotspotId] = useState(null);
  const [clickedHotspotId, setClickedHotspotId] = useState(null);
  const [viewportSize, setViewportSize] = useState(() => {
    // Guard against SSR (e.g., Next.js)
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    if (width <= 600) return 'tiny';
    if (width <= 1249) return 'mobile';
    return 'desktop';
  });

  // Original desktop positions
  const baseHotspots = [
    {
      id: 1,
      x: 340,
      y: 220,
      zoomImage: minimap1,
      descriptionKey: 'hotspot1',
      infoImage: minimap1,
    },
    {
      id: 2,
      x: 390,
      y: 295,
      zoomImage: minimap2,
      descriptionKey: 'hotspot2',
      infoImage: minimap2,
    },
    {
      id: 3,
      x: 260,
      y: 200,
      zoomImage: minimap3,
      descriptionKey: 'hotspot3',
      infoImage: minimap3,
    },
    {
      id: 4,
      x: 720,
      y: 450,
      zoomImage: minimap4,
      descriptionKey: 'hotspot4',
      infoImage: minimap4,
    },
    {
      id: 5,
      x: 130,
      y: 120,
      zoomImage: minimap6,
      descriptionKey: 'hotspot5',
      infoImage: minimap6,
    }
  ];

  // Mobile positions
  const mobileHotspots = [
    {
      id: 1,
      x: 165,
      y: 115,
      zoomImage: minimap1,
      descriptionKey: 'hotspot1',
      infoImage: minimap1,
    },
    {
      id: 2,
      x: 190,
      y: 150,
      zoomImage: minimap2,
      descriptionKey: 'hotspot2',
      infoImage: minimap2,
    },
    {
      id: 3,
      x: 120,
      y: 100,
      zoomImage: minimap3,
      descriptionKey: 'hotspot3',
      infoImage: minimap3,
    },
    {
      id: 4,
      x: 365,
      y: 230,
      zoomImage: minimap4,
      descriptionKey: 'hotspot4',
      infoImage: minimap4,
    },
    {
      id: 5,
      x: 60,
      y: 65,
      zoomImage: minimap6,
      descriptionKey: 'hotspot5',
      infoImage: minimap6,
    }
  ];

  // New tiny hotspots (ADJUST THESE VALUES AS NEEDED)
  const tinyHotspots = [
    {
      id: 1,
      x: 80,
      y: 60,
      zoomImage: minimap1,
      descriptionKey: 'hotspot1',
      infoImage: minimap1,
    },
    {
      id: 2,
      x: 95,
      y: 75,
      zoomImage: minimap2,
      descriptionKey: 'hotspot2',
      infoImage: minimap2,
    },
    {
      id: 3,
      x: 60,
      y: 50,
      zoomImage: minimap3,
      descriptionKey: 'hotspot3',
      infoImage: minimap3,
    },
    {
      id: 4,
      x: 180,
      y: 115,
      zoomImage: minimap4,
      descriptionKey: 'hotspot4',
      infoImage: minimap4,
    },
    {
      id: 5,
      x: 30,
      y: 35,
      zoomImage: minimap6,
      descriptionKey: 'hotspot5',
      infoImage: minimap6,
    }
  ];

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 600) {
        setViewportSize('tiny');
      } else if (width <= 1249) {
        setViewportSize('mobile');
      } else {
        setViewportSize('desktop');
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const hotspots = 
    viewportSize === 'tiny' ? tinyHotspots :
    viewportSize === 'mobile' ? mobileHotspots :
    baseHotspots ;

  const getActiveHotspot = () => hotspots.find(h => h.id === activeHotspotId);
  const getClickedHotspot = () => hotspots.find(h => h.id === clickedHotspotId);

  return (
    <div className="map-container">

      <div className="main-map">
        <img 
          src={mainmap}
          alt="Main Map" 
          className="map-image"
        />

        {hotspots.map(hotspot => (
          <div 
            key={hotspot.id}
            className={`hotspot-dot ${clickedHotspotId === hotspot.id ? 'clicked' : ''}`}
            style={{ 
              left: hotspot.x,
              top: hotspot.y
            }}
            onMouseEnter={() => setActiveHotspotId(hotspot.id)}
            onMouseLeave={() => setActiveHotspotId(null)}
            onClick={() => setClickedHotspotId(
              clickedHotspotId === hotspot.id ? null : hotspot.id
            )}
          />
        ))}

        {activeHotspotId && (
          <div 
            className="secondary-map"
            style={{
              left: getActiveHotspot().x + 20,
              top: getActiveHotspot().y + 20
            }}
          >
            <img
              src={getActiveHotspot().zoomImage}
              alt="Zoomed Area"
              className="zoom-image"
            />
          </div>
        )}
      </div>

      <div className="description-panel">
        {(clickedHotspotId || activeHotspotId) ? (
          <div className="description-content">
            <h1>{translations[language].hotspots[
              getClickedHotspot()?.descriptionKey || 
              getActiveHotspot()?.descriptionKey
            ]}</h1>

            {(getClickedHotspot()?.infoImage || getActiveHotspot()?.infoImage) && (
              <img
                src={getClickedHotspot()?.infoImage || getActiveHotspot()?.infoImage}
                alt="Location Details"
                className="info-image"
              />
            )}

            {clickedHotspotId === 1 && 
              <div><Zicatela language={language} /></div>}
            {clickedHotspotId === 2 && 
              <div><Punta language={language} /></div>}
            {clickedHotspotId === 3 && 
              <div><Colorada language={language} /></div>}
            {clickedHotspotId === 4 && 
              <div><Puertecito language={language} /></div>}
            {clickedHotspotId === 5 && 
              <div><Palmarito language={language} /></div>}
          </div>
        ) : <p>{translations[language].clickPrompt}</p>}
      </div>
    </div>
  );
};

export default MapComponent2;